module.exports = __webpack_public_path__ + "images/410.gif";